import {useState, useEffect} from "react";
import API from "../logic/API";
import {Resolution} from "../logic/FetchResolver";
import {AppDetailsResponse} from "../views/pages/appDetails/AppDetailsContainer";

export type AppType = "core" | "available" | "installed";

/** A hook for fetching the details of a single app from the API */
function useAppDetails(appType: AppType, groupId: string, appId: string) {
  const [appDetails, setAppDetails] = useState<AppDetailsResponse>();
  const [loading, setLoading] = useState(true);

  const getAppDetails = async () => {
    setLoading(true);
    let res: Resolution<AppDetailsResponse>;

    if (appType === "installed") {
      res = await API.getInstalledApp(groupId, appId);
    } else if (appType === "available") {
      res = await API.getAvailableApp(groupId, appId);
    } else {
      res = await API.getCoreApp(appId);
    }
    setLoading(false);
    if (res.success && res.payload) {
      setAppDetails({
        ...res.payload,
        logo: "data:image/svg+xml;base64," + res.payload.logo,
      });
    } else {
      setAppDetails({} as AppDetailsResponse);
    }
  };

  useEffect(() => {
    getAppDetails();
  }, []);
  return {appDetails, loading};
}

export default useAppDetails;
